// TopVideoPopupNotification.js
'use strict';
import { connect } from 'react-redux';

import TopVideoPopupNotification from '../component/TopVideoPopupNotification.jsx';

import getOperationData from '../selector/getOperationData.js';
import getNotificationData from '../selector/getNotificationData.js';

import withNotificationDisplayedTracking from '../resource/withNotificationDisplayedTracking.js';

const mapStateToProps = (state, { notificationId }) => {
  const notificationLink = getNotificationData(
    state,
    notificationId,
    'data.link'
  );
  const notificationTag = getNotificationData(
    state,
    notificationId,
    'data.tag'
  );
  return {
    deviceWidth: getOperationData(state, ['device'], 'width'),
    userId: getNotificationData(state, notificationId, 'userId'),
    notificationStatus: getNotificationData(state, notificationId, 'status'),
    notificationLink,
    thumbnailUrl: getOperationData(
      state,
      ['oembed', notificationLink],
      'thumbnail_url'
    ),
    notificationTitle: getOperationData(
      state,
      ['oembed', notificationLink],
      'title'
    ),
    notificationTag,
    oembedType: getOperationData(state, ['oembed', notificationLink], 'type'),
    notificationPosition: getNotificationData(
      state,
      notificationId,
      'data.position'
    ),
    notificationExp: getNotificationData(state, notificationId, 'data.exp'),
  };
};

export default connect(
  mapStateToProps,
  null
)(withNotificationDisplayedTracking(TopVideoPopupNotification));
